<ng-template #template>
  <div [class]="model.cssClasses">
    <div class="svc-row__drop-indicator svc-row__drop-indicator--top"></div>
    <div class="svc-row__drop-indicator svc-row__drop-indicator--bottom"></div>
    <sv-ng-row [row]="row"></sv-ng-row>
  </div>
</ng-template>